import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { ResourceItem } from "@ServerTypes/resources/resources.schema";

const resourcesSlice = createSlice({
  name: "resources",
  initialState: [] as ResourceItem[],
  reducers: {
    setTaskResource: (_state: ResourceItem[], action: PayloadAction<ResourceItem[]>) => action.payload,
  },
});

const resourceCreatedSlice = createSlice({
  name: "resourceCreated",
  initialState: false,
  reducers: {
    setResourceCreated: (_state: boolean, action: PayloadAction<boolean>) => action.payload,
  },
});

export const { setTaskResource } = resourcesSlice.actions;
export const { setResourceCreated } = resourceCreatedSlice.actions;

export const resources = resourcesSlice.reducer;
export const resourceCreated = resourceCreatedSlice.reducer;

export default {
  resources,
  resourceCreated,
};
